/** The Live Android app row in the Publish card (release Plan 6): one app per project. */
export function liveApkBusy(b: { status?: string } | null): boolean {
  return b?.status === 'queued' || b?.status === 'running';
}

export function liveApkLabel(b: { status?: string } | null): string {
  if (!b) return 'Not built yet';
  if (liveApkBusy(b)) return 'Building… about a minute';
  if (b.status === 'succeeded') return 'Ready — updates itself when you publish';
  if (b.status === 'failed') return 'The last build failed';
  return '';
}
